import React, { FC, ReactNode, useState } from 'react';
import { GiftMembersContext, MemberBeneficiary } from './context';

const GiftMembersProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [totalSum, setTotalSum] = useState(0);
  const [beneficiaries, setBeneficiaries] = useState<MemberBeneficiary[]>([]);

  return (
    <GiftMembersContext.Provider value={{ beneficiaries, setBeneficiaries, totalSum, setTotalSum }}>
      {children}
    </GiftMembersContext.Provider>
  );
};

export default GiftMembersProvider;
